import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'
import StockApi from '@/api/stock/api_stock.js'

// Parcours patient et transferts entre services (04/10/2026) : capacité « soins » (médecin ou infirmier), comme le
// poste de soins ; les unités de soins viennent du référentiel be_stock.
async function requeteSoins(method, url, data, params) {
    const acces = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
    const jeton = acces && acces.data && acces.data.access_token
    if (!jeton) throw new Error('Accès aux soins indisponible.')
    const reponse = await Api()({ method, url, data, params, med_access_scoped: true, timeout: 20000, headers: { 'X-Soins-Access': jeton } })
    return reponse.data
}

export default {
    autoriserSortie(sejourId) {
        return requeteSoins('post', '/v1/admissions/' + sejourId + '/plan-discharge', {})
    },
    patientsPresents(tous) {
        return requeteSoins('get', '/v1/parcours/patients', undefined, tous ? { tous: 1 } : {})
    },
    parcoursPatient(patientId, consultationId) {
        return requeteSoins('get', '/v1/parcours/patients/' + patientId, undefined, consultationId ? { consultation_id: consultationId } : {})
    },
    transferer(sejourId, serviceId, motif) {
        return requeteSoins('post', '/v1/sejours/' + sejourId + '/transferts', { service_id: serviceId, motif: motif || null })
    },
    confirmerArrivee(transfertId) {
        return requeteSoins('post', '/v1/transferts/' + transfertId + '/arrivee', {})
    },
    annulerTransfert(transfertId) {
        return requeteSoins('post', '/v1/transferts/' + transfertId + '/annuler', {})
    },
    services() {
        return StockApi().get('/v1/settings/hospital-services').then(response => response.data)
    }
}
